import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {
  retrieveProducers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("producer/retrieveProducers").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  saveProducer({ commit }, producer) {
    commit("SET_LOADING", true);
    return postAPI("producer/saveProducer", producer).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  deleteProducer({ commit } , id) {
    commit("SET_LOADING", true);
    return postAPI("producer/deleteProducer/" + id).then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveProducerById({ commit }, id) {
    commit("SET_LOADING", true);
    return getAPI("producer/retrieveProducerById" , id)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  retrieveProducersBySearch({ commit }, request) {
    commit("SET_LOADING", true);
    return getAPI("producer/retrieveProducersBySearch" , request)
      .then((response) => {
        return response;
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  countProducers({ commit }) {
    commit("SET_LOADING", true);
    return getAPI("producer/count").then((res) => {
      return res;
    })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };